/* eslint-disable react/function-component-definition */
import React from 'react'
import { ViewMode } from '@/components/Gantt/gantt-task-react'
import { Col, Row, Radio } from 'antd'
import { InfoCircleOutlined, CheckOutlined } from '@ant-design/icons'

export type summaryData = {
  all_tasks: number
  done: number
  not_planned: number
  overdue_tasks: number
  planned: number
  upcoming: number
}
type ViewSwitcherProps = {
  onViewStatusChange: (status: string) => void
  onViewModeChange: (viewMode: ViewMode) => void
  summaryData: summaryData
}

type InforCircleProps = {
  color: string
}

const InforCircle: React.FC<InforCircleProps> = ({ color }) => {
  return <InfoCircleOutlined style={{ color: color, paddingRight: 5 }} />
}

export const ViewSwitcher: React.FC<ViewSwitcherProps> = ({
  onViewModeChange,
  onViewStatusChange,
  summaryData,
}) => {
  return (
    <Row>
      <Col span={16}>
        <div>
          <Radio.Group
            // size=""x
            defaultValue={'all'}
            onChange={(e) => onViewStatusChange(e.target.value)}
          >
            <Radio.Button value={'all'}>
              All ({summaryData.all_tasks})
            </Radio.Button>

            <Radio.Button value={'in_progress_overdue'}>
              <InforCircle color="#C03261" />
              <span>Overdue ({summaryData.overdue_tasks})</span>
            </Radio.Button>

            <Radio.Button value={'in_progress_upcoming'}>
              <InforCircle color="#EF9747" />
              <span>Upcoming ({summaryData.upcoming})</span>
            </Radio.Button>

            <Radio.Button value={'in_progress_planned'}>
              <span>Planned ({summaryData.planned})</span>
            </Radio.Button>
            <Radio.Button value={'not_start_not_planned'}>
              <span>Not Planned ({summaryData.not_planned})</span>
            </Radio.Button>
            <Radio.Button value={'done_on_time,done_overdue'}>
              <CheckOutlined style={{ paddingRight: 5, color: '#848484' }} />
              <span>Done ({summaryData.done})</span>
            </Radio.Button>
          </Radio.Group>
        </div>
      </Col>

      <Col span={8}>
        <div style={{ float: 'right' }}>
          <Radio.Group
            // size="large"
            defaultValue={ViewMode.Month}
            onChange={(e) => onViewModeChange(e.target.value)}
          >
            <Radio.Button value={ViewMode.Day}>Day</Radio.Button>
            <Radio.Button value={ViewMode.Week}>Week</Radio.Button>
            <Radio.Button value={ViewMode.Month}>Month</Radio.Button>
          </Radio.Group>
        </div>
      </Col>
    </Row>
  )
}
